import {Component, inject, OnInit} from '@angular/core';
import { ApisService, OauthService } from "@wms/services";
import { CommonModule } from '@angular/common';
import {BaseComponent, WmsDialogBodyComponent, WmsDialogComponent,WmsDialogHeaderComponent,WmsDialogFooterComponent,WmsMessageComponent} from '@wms/components';
import { FormsModule } from '@angular/forms';
import { DialogService } from '@wms/app/services/dialog/dialog.service';
import { forEach, isEmpty, find, get, remove, capitalize } from 'lodash-es';
import { getStudioUrl } from '@wms/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
  selector: 'wms-oauth-provider',
  imports: [
    FormsModule,
    CommonModule,
    WmsDialogComponent,
    WmsDialogBodyComponent,
    WmsDialogHeaderComponent,
    WmsDialogFooterComponent,
    WmsMessageComponent,
    TooltipModule
  ],
  standalone: true,
  templateUrl: './oauth-provider.component.html',
  styleUrls: ['./oauth-provider.component.less']
})
export class OauthProviderComponent extends BaseComponent implements OnInit {

  implicitFlow: boolean;
  //todo It should be initialised in loadProviders method
  isPreDefinedProvider: boolean = true;
  oAuthProviders: any;
  selectedProvider: any;
  providerScopeMap: any;
  callbackURL: any;
  copyMsg: any;
  oauthProviderConfigMessage: any;
  configuredProviders: any = [];
  apiConfiguredProviderSubscription: any;

  flow_options = [{
    'value': 'AUTHORIZATION_CODE',
    'key': 'Authorization Code'
  }, {
    'value': 'IMPLICIT',
    'key': 'Implicit(Not Recommended)'
  }];

  challenge_options = [{
    'value': 'S256',
    'key': 'S256'
  }, {
    'value': 'Basic',
    'key': 'Basic'
  }];

  accesstoken_options = [{
    'value': 'HEADER',
    'key': 'Header'
  }, {
    'value': 'QUERY',
    'key': 'Query'
  }];

  responsetype_options = [{
    'value': 'token',
    'key': 'Token'
  }, {
    'value': 'id_token',
    'key': 'Id Token'
  }];

  accessTokenParamName: any = {
    'HEADER': 'Bearer',
    'QUERY': 'access_token'
  };

  implicitIdentifier = 'implicit';
  pkceIdentifier = 'pkce';
  providerModelKeys = ['providerId', 'authorizationUrl', 'clientId', 'clientSecret', 'accessTokenUrl'];
  ignoreKeys = ['isActive', 'customField', 'scopeMap'];
  customScope: any = {};

  constructor(public apiService: ApisService, private dialogService: DialogService, public oAuthService: OauthService) {
    super();
    this.dialogService = inject(DialogService);
  }

  closeOAuthDialog(): void {
    this.dialogService.close('wm-oAuth-dialog');
  }
  saveoAuthConfig($event: any): void {
    $event.stopPropagation();
    $event.preventDefault();
    let oAuthConfig = {
      'providers': []
    };
    this.oauthProviderConfigMessage = null;
    if (this.validateCustomField(this.apiService.activeProvider)) {
      return;
    }
    this.removeUncheckedScopes();
    oAuthConfig.providers = this.configuredProviders;
    (this.oAuthService.addProvider(oAuthConfig) as Promise<any>).then((resp: any) => {
      this.projectService.getAppRunURL();
    }).catch((error: any) =>{
    });
    this.closeOAuthDialog();
  }



  prepareScopeMap() {
    this.apiService.activeProvider.scopeMap = {};
    forEach(this.apiService.activeProvider.scopes, (scope) => {
      this.apiService.activeProvider.scopeMap[scope.name] = true;
    });
  }

  validateCustomField(provider: any): boolean {
    let isInvalid = false;
    if (isEmpty(provider)) {
      return true;
    }
    forEach(this.providerModelKeys, (key) => {
      if (!provider[key]) {
        isInvalid = true;
        this.oauthProviderConfigMessage = {
          'type': 'error',
          'caption': capitalize(key) + ' is required'
        };
        return false;
      }
      return;
    });
    if (!provider.scopes) { //assign empty array as backend doesn't handle scopes property
      provider.scopes = [];
    }
    return isInvalid;
  }

  removeUncheckedScopes() {
    remove(this.apiService.activeProvider.scopes, (scope: any) => {
      return !this.apiService.activeProvider.scopeMap[scope.name];
    });
  }

  onSetAccessTokenChange(): void {
    this.apiService.activeProvider.accessTokenParamName = this.accessTokenParamName[this.apiService.activeProvider.sendAccessTokenAs]
  }

  copyURLToClipboard(): void {
    $(document).find('#provider-callback-url').select();
    document.execCommand('copy');
    this.copyMsg = 'Copied!';
  }

  changeCallbackURL(): void {
    this.callbackURL = getStudioUrl() + '/services/oauth2/' + (this.apiService.activeProvider.providerId || '{providerId}') + '/callback';
    if (this.apiService.activeProvider.oauth2Flow === 'IMPLICIT' || get(this.apiService.activeProvider, 'oAuth2Pkce.enabled') === true) {
      this.callbackURL = 'http://' + window.location.host + '/studio/oAuthCallback.html';
    }
  }

  //constructs the callback url for an implicit oauth flow based on the separator param
  getImplicitCallbackURL(separator: any) {
    return window.location.href.split(separator)[0] + '/oAuthCallback.html';
  }

  //function to add the custom scope to the provider
  addScope(provider: any) {
    if (this.customScope && this.customScope.key && this.customScope.value) {
      provider.scopeMap[this.customScope.key] = true;
      provider.scopes.push({
        name: this.customScope.key,
        value: this.customScope.value
      });
      this.customScope = {};
    }
  }

  onFlowChange() {
    if (this.apiService.activeProvider.oauth2Flow === "IMPLICIT") {
      this.implicitFlow = true;
      this.providerModelKeys = this.getPropertiesByProvider(this.implicitIdentifier);
    } else if (get(this.apiService.activeProvider, 'oAuth2Pkce.enabled') === true) {
      this.implicitFlow = false;
      this.apiService.activeProvider.oAuth2Pkce.challengeMethod = this.apiService.activeProvider.oAuth2Pkce.challengeMethod || this.challenge_options[0].value;
      this.providerModelKeys = this.getPropertiesByProvider(this.pkceIdentifier);
    } else {
      this.implicitFlow = false;
      this.providerModelKeys = this.getPropertiesByProvider('authCode');
    }
    this.changeCallbackURL();
  }

  //function to get required fields based on oauth flow. Access token url and client secret are not required for implicit flow.
  getPropertiesByProvider(flow: any) {
    if (flow === this.implicitIdentifier) {
      return ['providerId', 'authorizationUrl', 'clientId', 'sendAccessTokenAs', 'responseType', 'accessTokenParamName', 'scopes'];
    } else if (flow === this.pkceIdentifier) {
      return ['providerId', 'authorizationUrl', 'accessTokenUrl', 'clientId', 'sendAccessTokenAs', 'accessTokenParamName', 'scopes'];
    } else {
      return ['providerId', 'authorizationUrl', 'accessTokenUrl', 'clientId', 'clientSecret', 'sendAccessTokenAs', 'accessTokenParamName', 'scopes'];
    }
  }

  //function to load the configured providers
  loadConfiguredProviders(response: any) {
    this.configuredProviders = response || [];
    if (this.apiService.activeProvider.providerId) {
        this.apiService.activeProvider = find(this.configuredProviders, {providerId: this.apiService.activeProvider.providerId});
        if (!this.apiService.activeProvider) {
            this.apiService.activeProvider = {};
        }
        this.isPreDefinedProvider = true;
    } else {
        this.apiService.activeProvider = {
            'providerId': '',
            'authorizationUrl': '',
            'accessTokenUrl': '',
            'clientId': '',
            'clientSecret': '',
            'scopes': []
        };
        this.configuredProviders.push(this.apiService.activeProvider);
    }
    if (!this.apiService.activeProvider.sendAccessTokenAs) {
      this.apiService.activeProvider.sendAccessTokenAs = 'HEADER';
    }
    if (!this.apiService.activeProvider.responseType) {
      this.apiService.activeProvider.responseType = 'token'
    }
    if (!this.apiService.activeProvider.oauth2Flow) {
      this.apiService.activeProvider.oauth2Flow = 'AUTHORIZATION_CODE';
    }
    this.onSetAccessTokenChange();
    this.onFlowChange();
    this.prepareScopeMap();
    this.changeCallbackURL();
  }

  ngOnInit(): void {
    this.apiConfiguredProviderSubscription = this.apiService._apiConfiguredProviderSubject.subscribe((response: any) => {
      this.loadConfiguredProviders(response);
    });
  }
  override ngOnDestroy() {
    super.ngOnDestroy();
    if (this.apiConfiguredProviderSubscription) {
      this.apiConfiguredProviderSubscription.unsubscribe();
    }
  }

}
